import { useTLang } from 'intl/intl';

export function useStoreSelectorLang() {
  return {
    header: {
      title: useTLang({ id: 'menuPage.selectStore.header.title' }),
    },
    actions: {
      primaryBtn: useTLang({ id: 'menuPage.selectStore.actions.primaryBtn' }),
    },
  };
}
